import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControlLabel, Radio, RadioGroup, Switch, TextField } from '@mui/material'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import Page from '../../component/Page'
import { getData, putData } from '../../services/api'
import RequireField from '../../component/RequireField'

export default function RoleView() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [roleName, setRoleName] = useState()
  const [detail, setDetail] = useState()
  const [action, setAction] = useState()
  const [Status, setStatus] = useState('Y')
  const [Permissions, setPermissions] = useState([])
  const [nameError, setNameError] = useState(false);

  useEffect(() => {
    getData('dbms/admin-roles/', id).then((response) => {
      setDetail(response.result)
      setRoleName(response.result?.RoleName)
      setStatus(response.result?.Status)
      setPermissions(response.result?.Permissions)
      setAction(response.result?.Permissions[0])
    })
  }, [])


  const handleSubmit = async () => {
    const body = {
      RoleId: id,
      RoleName: roleName,
      Permissions: Permissions,
      Status: Status
    }
    const url = 'dbms/admin-roles/' + id
    if (!roleName) {
      setNameError(true)
    } else {
      putData(url, body).then((response) => {
        if (response.status === true) {
          Swal.fire(
            'ทำรายการสำเร็จ',
            '',
            'success'
          )
          getData('dbms/admin-roles/', id).then((response) => {
            setDetail(response.result)
            setRoleName(response.result?.RoleName)
            setStatus(response.result?.Status)
            setPermissions(response.result?.Permissions)
            setAction(response.result?.Permissions[0])
          })
        }else {
          Swal.fire({
              title: response?.message || 'ทำรายการไม่สำเร็จ',
              icon: 'warning',
          })
      }

      })
    }

  }
  return (
    <div style={{ padding: '10px 30px' }}>
      <Page>
        <form >
          <div class="container-fluid" >

            <div class=" d-flex row justify-content-between align-items-baseline">
              <div class="col-lg-12 col-md-12 text-left ">
                <label class="title-content mb-4">
                  ข้อมูลกลุ่มผู้ใช้งาน
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-sm-12 ">
                <label class="labelInput">ชื่อกลุ่ม</label>
                <RequireField value={roleName} onChange={setRoleName} type={'text'} error={nameError} setError={setNameError} textError={'กรุณากรอกชื่อกลุ่ม'} />
              </div>

              {id &&
                <div class="row" >
                  <div class="col-lg-4 col-md-6">
                    <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                      <TextField value={detail?.CreateId} variant="standard" fullWidth disabled={id ? true : false}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                      <TextField value={detail?.ModifiedId} variant="standard" fullWidth disabled={id ? true : false}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                  </div>
                </div>}
              <div class="row" >
                <div class="col-12 mt-1  text-left ">
                  <RadioGroup row value={Status} onChange={e => setStatus(e.target.value)}>
                    <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                    <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                  </RadioGroup>
                </div>
              </div>


              <hr class="chr" />
              <div class="row" >
                <div class="col-sm-12 col-lg-4">
                  <div class="border-row" >
                    <div class=" d-flex justify-content-between">
                      <div >
                        <label class="title-content">เมนู</label>
                      </div>

                    </div>
                    <div class="row mt-2" >
                      <div class="Warehouse col-12">
                        <div class="table-responsive-sm">
                          <table class="table table-borderless table-hover">
                            <thead>
                              <tr>
                                <th class="text-center">ชื่อ</th>

                              </tr>
                            </thead>
                            <tbody>
                              {Permissions?.map((x, i) => (
                                <tr class={`${x?.Subject === action.Subject ? 'active' : ''}`} onClick={() => setAction(x)}>
                                  <td>{x?.Subject}</td>
                                </tr>

                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 col-lg-8">
                  <div class="border-row">
                    <div class=" d-flex justify-content-between">
                      <div >
                        <label class="title-content">รายละเอียด</label>
                      </div>

                    </div>
                    <div class="row mt-2">
                      <div class="Warehouse col-12">
                        <div class="table-responsive-sm">
                          <table class="table table-borderless table-hover">
                            <thead>
                              <tr>
                                <th style={{ width: "80%" }}>ชื่อ</th>
                                <th style={{ width: "20%" }}>สถานะ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {action?.Actions?.map((x, i) => (
                                <tr>
                                  <td >{x?.Name}</td>
                                  <td class="text-center">
                                    <Switch checked={x?.Permit}
                                      onChange={e => {
                                        const item = action?.Actions?.map((z, index) => {
                                          z.Permit = i === index ? e.target.checked : z?.Permit
                                          return z
                                        })
                                        const Permis = Permissions?.map((n, index) => {
                                          n.Actions = n?.Subject === action?.Subject ? item : n?.Actions
                                          return n
                                        })
                                        setAction({
                                          Subject: action?.Subject,
                                          Actions: item
                                        })
                                        setPermissions(Permis)
                                      }} />
                                  </td>

                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <hr class="chr" />

              <div class="row ">
                <div class="col-12 text-left">
                  <Button variant='outlined' onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                  <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => handleSubmit()}>{'บันทึก'} </Button>
                </div>
              </div>
            </div>
          </div>


        </form>
      </Page>
    </div>
  )
}
